<header class="header">
  <div class="wrapper wrap">
      <a href="https://www.westberks.gov.uk/"><img class="header-logo"
      src="/assets/images/logo.png"
      alt="West Berkshire Council" /></a>

  </div>
</header>